var voted_users_rtlignore_default = {
  "container": "_34DeT",
  "webview": "_1JUSa",
  "avatar_list": "t3u9x",
  "avatar": "bZett",
  "user_avatar": "kjv5F",
  "modal": "s5tIw",
  "voted_users_modal": "NQTcM",
  "overlay": "yPW95",
  "user_card": "_0hANx",
  "user_name": "Cbw-g",
  "voted_users_modal_header": "elGIa",
  "cta": "_6epVM",
  "close_icon": "LtsOC",
  "title": "LUVPq",
  "member_list_container": "_2ZKkO",
  "member_list": "pyWY1",
  "loader": "eSASV",
  "anonymous_counter": "FaTt4",
  "spinner": "_8ymCi",
  "spin": "_-1JI2"
};
export {
  voted_users_rtlignore_default as default
};
//# sourceMappingURL=voted-users.rtlignore-scss.js.map
